import { Routes, Route, useParams } from "react-router-dom";
import {FaChevronLeft,FaIndent,FaOutdent} from "react-icons/fa";
import { useState, useEffect } from "react";
import PanelSidebar from "../Sidebar";
import "./PanelLayout.css";
import { generatePanelRoutes } from "../../utils/generatePanelRoutes";
import axios from "axios";
import BubbleNetwork from "../../components/logo/BubbleNetwork";
import FeedbackPage from "../../pages/panels/FeedbackPage";

const PanelLayout = () => {
  const { panel } = useParams();

  const panelToRoleMap = {
    "admin-panel": "admin",
    "customer-panel": "customer care",
    "emailer-panel": "emailer",
    "partner-panel": "partner",
  };

  const role = panelToRoleMap[panel];
  console.log("Current role:", role);
  const [collapsed, setCollapsed] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    const fetchPermissions = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/rolepermission/${role}/permissions`
      );
      setPermissions(res.data);
    };
    fetchPermissions();
  }, [panel,role]);

  useEffect(() => {
    const dynamicRoutes = generatePanelRoutes(permissions);
    setRoutes(dynamicRoutes);
  }, [permissions]);

  console.log('Current routes:', routes);
  console.log('Current permissions:', permissions);

  return (
    <div className="panel-layout">
      {/* Desktop flex spacer — hidden on mobile via CSS */}
      <aside className={`panel-spacer ${collapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          {!collapsed && (
            <>
              <BubbleNetwork />
              <h2>Medhas AI</h2>
            </>
          )}
          <button
            className="collapse-btn"
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? <span><BubbleNetwork /></span> : <FaOutdent />}
          </button>
        </div>
      </aside>

      {/*
        PanelSidebar renders:
          1. .hamburger-button  (position: fixed — visible everywhere)
          2. .mobile-overlay    (position: fixed — mobile only)
          3. .sidebar-container (position: fixed — the real nav panel)
        Keeping it OUTSIDE the aside so hiding the aside doesn't hide the hamburger.
      */}
      <PanelSidebar role={role} collapsed={collapsed} />

      <main className="main-content">
        <Routes>
          {routes.map(({ path, element }, index) => {
            console.log(`Rendering route: ${path}`);
            return <Route key={index} path={path} element={element} />;
          })}
          <Route 
            path="feedback_management/*" 
            element={<FeedbackPage />} 
          />
          <Route 
            path="*" 
            element={
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Welcome to Admin Panel</h2>
                <p>Please select an option from the sidebar to get started.</p>
              </div>
            } 
          />
        </Routes>
      </main>
    </div>
  );
};

export default PanelLayout;
